import { useEffect, useState } from "react";
import { leadsStats } from "../lib/api";

// Today's numbers for the agent, and for every person when an admin is looking.
export default function YourDay({ reloadKey }) {
  const [s, setS] = useState(null);
  useEffect(() => { leadsStats().then(setS).catch(() => {}); }, [reloadKey]);
  if (!s) return null;
  const tiles = [["Calls today", s.calls], ["Spoke to", s.connected], ["Interested", s.interested], ["Meetings booked", s.meetings], ["Connect rate", `${s.connect_rate}%`]];
  return <section className="your-day" data-testid="your-day">
    <div className="support-tiles">{tiles.map(([label, n]) => <div key={label} className="kpi support-tile"><small>{label}</small><b>{n}</b></div>)}</div>
    {s.team.length > 0 && <div className="panel full-table"><table><thead><tr><th>Team today</th><th>Calls</th><th>Spoke to</th><th>Interested</th><th>Meetings</th></tr></thead><tbody>
      {s.team.map(t => <tr key={t.name}><td><b>{t.name}</b></td><td>{t.calls}</td><td>{t.connected}</td><td>{t.interested}</td><td>{t.meetings}</td></tr>)}</tbody></table></div>}
  </section>;
}
